// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"de6b50a1","186":"64e6cef2","225":"16abb6e7","344":"4ce49318","372":"d18adfed","573":"ddbebf2d","738":"e6010cc6","841":"c579df81","856":"d9bf6370","909":"4aee2055"}[chunkId] + ".chunk.js";
};